import styled from 'styled-components'

export const TextCell = styled.div`
  color: var(--text-11);

  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
`
